/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'assets/js/modules/View',
        'assets/js/modules/designFacePreview/designFacePreviewService',
        'assets/js/modules/product/model/attributeModel',
        'assets/js/modules/widgets/uploadInfo/uploadInfoModel',
        'assets/js/modules/widgets/uploadInfo/uploadInfoView',
        'selectboxit/src/javascripts/jquery.selectBoxIt.min'
    ],
    function($, View, designFacePreviewService, AttributeModel, UploadInfoModel, UploadInfoView) {
        return View.extend({
            $products: null,
            $preview: null,

            events: {
                'change #upload-size': 'updatePreview'
            },

            initialize: function(options) {
                this.$products = this.$el.find('#upload-size');
                this.$preview = this.$el.find('.print-zones-preview');

                this.renderProducts();
                this.renderPreview();
            },

            renderProducts: function() {
                var $productSizeContainer = this.$el.find('#upload-size-box');
                var $productSize = this.$el.find('#upload-size');
                var selectedProductSlug = this.model.get('slug');
                var productHtml = '';
                this.collection.each(function(product) {
                    var selected = product.get('slug') === selectedProductSlug;
                    productHtml +=
                        '<option value="' +
                        product.get('slug') +
                        '"' +
                        (selected ? ' selected' : '') +
                        '>' +
                        product.get('name') +
                        '</option>';
                });
                $productSize.html(productHtml);
                $productSize.selectBoxIt();
                $productSize.data('selectBox-selectBoxIt').refresh();

                if (this.collection.length === 1) {
                    $productSizeContainer.hide();
                }
            },

            updatePreview: function() {
                this.updateModel();
                this.renderPreview();
            },

            updateModel: function() {
                var slug = this.$products.val();
                this.model = this.collection.findWhere({ slug: slug });
            },

            renderPreview: function() {
                var _this = this;

                new UploadInfoView({
                    model: _this.createUploadInfoModel(),
                    el: _this.$preview
                });
            },

            /**
             * @return {UploadInfoModel}
             */
            createUploadInfoModel: function() {
                var product = this.model;
                var productPreviewInfo = designFacePreviewService.getProductPreviewInfoFromProduct(product);

                return new UploadInfoModel({
                    productPreviewInfo: productPreviewInfo,
                    productSlug: product.get('slug'),
                    linearUnitSign: product.getAttributeValue(AttributeModel.NAME_LINEAR_UNIT_SIGN)
                });
            }
        });
    }
);
